export let navbar = [
    {
        "role":"user",
        "name":"Home",
        "link":"/home",
    },
    {
        "role":"user",
        "name":"Plant Tracker",
        "link":"/dashboard",
    },
    {
        "role":"user",
        "name":"FootPrint Calculator",
        "link":"/footprint",
    },
    {
        "role":"user",
        "name":"Gaming Zone",
        "link":"/createroom",
    },
    {
        "role":"user",
        "name":"Forest",
        "link":"/forest",
    },
    {
        "role":"user",
        "name":"Analytics",
        "link":"/analytics",
    },
]